/**
 * Colors_T42.jsx
 * Identity for B2C Template 42 — "Azure Voyage" Theme
 * Navy Blue / Warm Orange / Sky Blue palette. Vibrant, trusted, Indian travel agency style.
 */
import { getAssetUrl } from '../../Common/Utils/assetUrl';
export const mapB2CTenantToLanding = (tenantData) => {
  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId,
    userId:          tenantData?.userId,
    logoUrl: getAssetUrl(tenantData?.branding?.logoUrl),
    brandName:       tenantData?.branding?.brandName    || 'Azure Travels',
    companyName:     tenantData?.branding?.companyName  || 'Azure Travels',
    email:           tenantData?.branding?.email        || 'support@azuretravels.com',

    phones:          Array.isArray(tenantData?.branding?.phones)
                     ? tenantData?.branding?.phones[0]
                     : tenantData?.branding?.phones || '9000000000',

    whatsapp:        tenantData?.branding?.whatsapp     || '9000000000',
    socials:         tenantData?.branding?.socials      || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

    themeColor1:     tenantData?.theme?.themeColor1 || tenantData?.theme?.themecolor1,
    themeColor2:     tenantData?.theme?.themeColor2 || tenantData?.theme?.themecolor2,
    themeColor3:     tenantData?.theme?.themeColor3 || tenantData?.theme?.themecolor3,
    themeColor4:     tenantData?.theme?.themeColor4 || tenantData?.theme?.themecolor4,
    themeColor5:     tenantData?.theme?.themeColor5 || tenantData?.theme?.themecolor5,

    headerBgOverride:   tenantData?.header?.bgColor,
    headerTextOverride: tenantData?.header?.textColor,
    footerBgOverride:   tenantData?.footer?.bgColor,
    footerTextOverride: tenantData?.footer?.textColor,

    headingFont: tenantData?.branding?.headingFont || 'Poppins',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Inter',

    heroData:        tenantData?.hero,
    aboutUs:         tenantData?.aboutUs,
    contactUs:       tenantData?.contactUs,
    activeModules:   tenantData?.activeModules,
  };
};

export const getB2CColors_T42 = (landingData) => {
  const navy      = landingData?.themeColor1 || '#312F92';  // Deep Navy Blue — primary CTA, hero bg
  const footerDark= landingData?.themeColor2 || '#0d1f4e';  // Very dark navy — footer
  const headerBg  = landingData?.themeColor3 || '#ffffff';  // Header background
  const sky       = landingData?.themeColor4 || '#0F3672';  // Sky Blue — secondary accent
  const pageBg    = landingData?.themeColor5 || '#f0f5ff';  // Light blue-tinted page background
  const orange    = '#B78439';                               // Warm Orange — accent, buttons, highlights

  return {
    theme1: navy,
    theme2: landingData?.footerBgOverride || footerDark,
    theme3: landingData?.headerBgOverride || headerBg,
    theme4: sky,
    theme5: pageBg,
    orange: orange,

    headerText: landingData?.headerTextOverride || '#0F3672',
    footerText: landingData?.footerTextOverride || '#e2e8f0',

    topBarBg:   '#0F3672',
    topBarText: '#ffffff',
  };
};

export const toRgba = (color, alpha = 1) => {
  if (!color || !color.startsWith('#')) return color;
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
